<!-- Summary: accepted value + payment summary + payment details -->
<div class="sec-dsk-summary">
	<div class="sum-wrap">
		<div class="sum-top">
			<div class="sum-title">Total Project <br>Accepted Value</div>
			<div class="sum-total">
				<div class="sum-total-value">{{ summary.total_accepted | currency:currency }}</div>
				<div class="sum-total-label">Total Value (excl. Tax)</div>
			</div>
		</div>
		<div class="sum-body">
			<div class="sum-summary-label">Payment Summary</div>
			<div class="sum-amount-row">
				<span class="sum-amount">{{ payment.paid | currency:currency }}</span>
				<span class="sum-amount-of">of {{ payment.total | currency:currency }} Paid so far</span>
			</div>
			<portal-progress-bar size="lg" [paid]="payment.paid" [toPay]="payment.to_pay_now" [total]="payment.total"></portal-progress-bar>
			<div class="sum-legend">
				<div class="sum-legend-item">
					<div class="sum-legend-label"><div class="sum-legend-dot" style="background:var(--c-success-solid);"></div>Paid so far</div>
					<div class="sum-legend-value">{{ payment.paid | currency:currency }}</div>
				</div>
				<div class="sum-legend-item">
					<div class="sum-legend-label"><div class="sum-legend-dot" style="background:var(--c-primary-solid);"></div>To pay now</div>
					<div class="sum-legend-value">{{ payment.to_pay_now | currency:currency }}</div>
				</div>
				<div class="sum-legend-item">
					<div class="sum-legend-label"><div class="sum-legend-dot sum-legend-dot-upcoming"></div>Upcoming</div>
					<div class="sum-legend-value">{{ payment.upcoming | currency:currency }}</div>
				</div>
			</div>
		</div>
	</div>

	<div class="sum-details" *ngIf="paymentDetails">
		<div class="sum-details-title">Payment details</div>
		<div class="sum-details-company">{{ paymentDetails.company_name }}</div>
		<div class="sum-details-address">
			<span *ngFor="let line of paymentDetails.address_lines; let last = last">{{ line }}<br *ngIf="!last"></span>
		</div>
	</div>
</div>
